import { OfflineDB, Sync, useCompaniesStore, } from "@sicarx/sxw-api"
import { Update } from "../workers/types"

interface SicarxProps {
    baseURL: string
}

export const setSicarxProperties = (props: SicarxProps) => {

    const isWebProduction = isWebProductionFn()

    Object.defineProperty(window, 'sicarx', {
        get: () => ({
            baseURL: props.baseURL,
            isWebProduction
        }),
    })

    Object.defineProperty(window, 'offline', {
        get: () => ({
            resendFailedSales: resendFailedSales
        }),
    })
}


const isWebProductionFn = () => {
    const hosts = [
        'app.sicarx.com',
        'pre-production-dot-sicar-x.uc.r.appspot.com',
    ]
    return hosts.includes(window.location.host)
}

const resendFailedSales = async () => {

    const branchId = useCompaniesStore.getState().companies.branchOffice.id

    OfflineDB.transaction('readwrite', [OfflineDB.documents], async () => {

        const documents = await OfflineDB.documents.where({ branchId, syncStatus: Sync.SyncStatus.ERROR }).toArray()

        const changes: Update<[number, string], Pick<Sync.SyncDocument, 'syncStatus'>>[] = documents.map((d) => ({
            key: [branchId, d.uuid!], changes: { syncStatus: Sync.SyncStatus.ACTIVE }
        }))

        await OfflineDB.documents.bulkUpdate(changes)

    }).catch(err => {
        console.warn('Sync::ResendFaildSales', err?.message)
    })




}   